export default __webpack_public_path__ + "static/media/XAVA.daea44f1.png";